<script>
	import axios from 'axios';
	import mixin from '../../mixin';

	export default {
		mixins: [mixin],
		props: {
			idFromUrl: {
				type: String,
				default: null,
			},
		},
		data() {
			return {
				conversationsData: [],
			};
		},
		async mounted() {
			await this.fetchData(this.idFromUrl);
		},
		methods: {
			async fetchData(idFromURL) {
				try {
					const response = await axios.get(`/api/dossiers/${idFromURL}/gesprekken`);
					if (response ?? response.data) {
						this.conversationsData = response.data.map((conversation) => {
							return {
								...conversation,
								isActive: false,
							};
						});
					} else {
						console.error('Invalid data received:', response);
					}
				} catch (error) {
					console.error('Error fetching data:', error);
				}
			},
			selectConversation(index) {
				this.conversationsData = this.conversationsData.map((conversation) => {
					return {
						...conversation,
						isActive: false,
					};
				});
				this.conversationsData[index].isActive = true;
			},
		},
	};
</script>

<template>
	<div class="conversations table-container">
		<template v-if="conversationsData.length">
			<div class="box content">
				<p class="is-size-8 mb-5">{{ $store.getters.getRightText('dossierdetailTableHeadConversationsIntro') }}</p>
				<p>{{ $store.getters.getRightText('dossierdetailTableHeadConversationsConversation') }}</p>
				<p v-if="conversationsData.some((c) => c.isActive)">{{ conversationsData.find((c) => c.isActive).gesprek }}</p>
			</div>
			<table class="table table--small is-fullwidth is-bordered is-hoverable is-clipped table--alternative">
				<thead>
					<tr>
						<th></th>
						<th>{{ $store.getters.getRightText('dossierdetailTableHeadConversationsDate') }}</th>
						<th>{{ $store.getters.getRightText('dossierdetailTableHeadConversationsConversation') }}</th>
					</tr>
				</thead>
				<tbody>
					<tr
						v-for="(conversation, index) in conversationsData"
						:key="index"
						@click="selectConversation(index)"
						class="is-clickable"
					>
						<td>
							<div class="control">
								<input
									class="by-radio"
									type="radio"
									:id="`radio-${index}`"
									:checked="conversation.isActive"
								/>
								<label class="by-checkable" :for="`radio-${index}`"></label>
							</div>
						</td>
						<td>{{ toDateStrShortMnth(conversation.datum) }}</td>
						<td colspan="4" class="is-truncated">{{ conversation.gesprek }}</td>
					</tr>
				</tbody>
			</table>
		</template>
		<template v-else>
			<div class="box">
				{{ $store.getters.getRightText('dossierdetailLabelNoResults') }}
			</div>
		</template>
	</div>
</template>


